import { api } from '../api';

// Unwrap the ApiResponse {success, data} envelope; lists stay as
// PageResponse {content, ...} for callers that page.
const unwrap = (r) => r.data?.data ?? r.data;

export default {
  /* ── appointments ── */
  list:         (params)     => api.get('/v1/appointments', { params }).then(unwrap),
  create:       (body)       => api.post('/v1/appointments', body).then(unwrap),

  /**
   * Diary view.
   *
   * params {
   *   from, to,                       ISO instants (use orgRange() to build them)
   *   types,                          CSV of Appointment.Type   — omit for all
   *   statuses,                       CSV of Appointment.Status — omit for all
   *   consultantIds,                  CSV of consultant ids     — omit for all
   *   locationIds,                    CSV of location ids       — omit for all
   *   vehicleCategory,                CSV of NEW|USED|DEMO|UNKNOWN
   *   consultantId                    DEPRECATED singular — use consultantIds
   * }
   *
   * Filtering is server-side: the old client-side filter silently dropped
   * anything outside the rows the diary happened to return.
   */
  diary:        (params)     => api.get('/v1/appointments/diary', { params }).then(unwrap),

  /**
   * Filter options for the diary, independent of what is currently loaded.
   * The old consultant filter listed only consultants who already had an
   * appointment in view, so anyone with a quiet week disappeared from it.
   * params { from, to } → { consultants[], locations[], types[], statuses[] }
   */
  filterOptions: (params)    => api.get('/v1/appointments/filter-options', { params }).then(unwrap),

  get:          (id)         => api.get(`/v1/appointments/${id}`).then(unwrap),
  updateStatus: (id, body)   => api.patch(`/v1/appointments/${id}/status`, body).then(unwrap),      // {status, reason, outcomeCode}
  reschedule:   (id, body)   => api.patch(`/v1/appointments/${id}/reschedule`, body).then(unwrap),  // {startsAt, endsAt}
  // Consultants who are free + working for this appointment's window → [{id, name}]
  availableConsultants: (id) => api.get(`/v1/appointments/${id}/available-consultants`).then(unwrap),
  changeConsultant:     (id, consultantId) => api.patch(`/v1/appointments/${id}/consultant`, { consultantId }).then(unwrap),

  /* ── diary: slots & availability ── */
  slots:        (params)     => api.get('/v1/diary/slots', { params }).then(unwrap),         // {date, consultantId, type}
  availability: (params)     => api.get('/v1/diary/availability', { params }).then(unwrap),  // {consultantId, date}

  /* ── diary: working schedules ── */
  schedules:      (params)     => api.get('/v1/diary/schedules', { params }).then(unwrap),
  createSchedule: (body)       => api.post('/v1/diary/schedules', body).then(unwrap),
  updateSchedule: (id, body)   => api.patch(`/v1/diary/schedules/${id}`, body).then(unwrap),
  deleteSchedule: (id)         => api.delete(`/v1/diary/schedules/${id}`).then(unwrap),

  /* ── diary: blocks (time off / holds) ── */
  blocks:      (params) => api.get('/v1/diary/blocks', { params }).then(unwrap),
  createBlock: (body)   => api.post('/v1/diary/blocks', body).then(unwrap),
  deleteBlock: (id)     => api.delete(`/v1/diary/blocks/${id}`).then(unwrap),
};
